<template>
  <div class="solution-detail">
    <!-- <div class="title">算能解决方案 助力数字中国建设，让国产算力普惠千行百业</div> -->
    <div class="content-box">
      <section class="title">
        <img src="../../assets/decorate-left.png" alt />{{ detail.projectName }}
        <img src="../../assets/decorate-right.png" alt />
      </section>
      <div class="menu-box menu-fix" ref="menu">
        <div
          class="menu"
          :style="{ backgroundColor: lang === 'zn' ? '#f2f6ff' : '' }"
        >
          <div class="back-first" @click="handleBack">
            <van-icon name="arrow-left" v-if="lang === 'zn'" />
            <!-- <van-button
              v-if="lang === 'en'"
              type="info"
              hairline
              :text="$t('返回')"
              size="small"
              style="font-size: 0.45rem"
            >
            </van-button> -->
            <div v-if="lang === 'en'" class="img"></div>
          </div>
          <div v-if="lang === 'zn'">
            <a
              data="desc"
              @click="scrollToElement('desc')"
              class="nav desc-nav sub-title selected"
              >{{ $t("方案概述") }}</a
            >
            <a
              data="programValue"
              @click="scrollToElement('programValue')"
              class="nav programValue-nav sub-title"
              >{{ $t("方案价值") }}</a
            >
            <a
              data="solutionArchitecture"
              @click="scrollToElement('solutionArchitecture')"
              class="nav solutionArchitecture-nav sub-title"
              >{{ $t("方案架构图") }}</a
            >
            <a
              data="products"
              @click="scrollToElement('products')"
              class="nav sub-title products-nav"
              id=""
              >{{ $t("相关产品") }}</a
            >
            <a
              data="aiCase"
              v-if="detail.typicalCase && detail.typicalCase.length"
              @click="scrollToElement('aiCase')"
              class="nav aiCase-nav sub-title"
              >{{ $t("典型案例") }}</a
            >
            <a
              data="consult"
              @click="scrollToElement('consult')"
              class="nav sub-title consult-nav"
            >
              {{ $t("项目咨询") }}</a
            >
          </div>
          <!-- <div @click="handleConsult()" class="consult" v-if="lang === 'zn'">
            {{ $t("项目咨询") }}
          </div> -->
        </div>

        <section class="desc project" id="desc">
          <div class="subtitle">{{ $t("方案概述") }}</div>
          <div class="content">
            {{ detail.projectDescription }}
          </div>
        </section>
        <div class="program-value project" id="programValue">
          <div class="subtitle">{{ $t("方案价值") }}</div>
          <div
            class="content"
            :key="index"
            v-for="(item, index) in detail.projectValue"
          >
            <div class="layout-title">
              <img src="../../assets/decorate-icon.png" alt />
              {{ item.valueName }}
            </div>
            <div class="layout-des">{{ item.valueDescription }}</div>
          </div>
        </div>
        <div class="solution-architecture project" id="solutionArchitecture">
          <div class="subtitle">{{ $t("方案架构图") }}</div>
          <div class="img-box">
            <img :src="detail.projectArchitectureImageUrl" alt="方案架构图" />
          </div>
        </div>
        <div
          class="ai-power-products project"
          id="products"
          v-if="detail.typicalCase && detail.aiProducts.length"
        >
          <div class="subtitle">{{ $t("相关产品") }}</div>
          <van-swipe class="my-swipe" indicator-color="#fff" :autoplay="3000">
            <van-swipe-item
              v-for="(item, index) in detail.aiProducts"
              :key="index"
            >
              <div class="swiper-content">
                <div class="products-title">
                  <img src="../../assets/decorate-icon.png" alt />{{
                    item.aiProductName
                  }}
                </div>
                <div class="products-desc">{{ item.aiProductDescription }}</div>
              </div>
              <div class="swiper-img">
                <img :src="item.aiProductImageUrl" alt="产品图" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div
          class="ai-case project"
          id="aiCase"
          v-if="detail.typicalCase && detail.typicalCase.length"
        >
          <div class="subtitle">{{ $t("典型案例") }}</div>
          <van-swipe class="my-swipe" indicator-color="#fff" :autoplay="3000">
            <van-swipe-item
              v-for="(item, index) in detail.typicalCase"
              :key="index"
            >
              <div class="swiper-content">
                <div class="case-title">
                  <img src="../../assets/decorate-icon.png" alt />{{
                    item.caseName
                  }}
                </div>
                <div class="case-desc" v-html="item.caseDescription"></div>
              </div>
              <div class="swiper-img">
                <img :src="item.caseImageUrl" alt="典型案例图" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <section class="target" id="target" v-if="detail.experienceUrl">
          <button
            :disabled="!detail.experienceUrl"
            @click="handleGo(detail.experienceUrl)"
          >
            {{ $t("在线体验") }}
          </button>
          <div class="tips">{{ $t("（账号密码联系我们获取）") }}</div>
        </section>
      </div>
      <form-page class="consult project" id="consult"></form-page>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import FormPage from "./Form.vue";
import { Debounce } from "@/common/decorators.js";
let defaultModel = {
  projectName: "",
  functionIntroduction: "",
  detailImageUrl: "",
  experienceUrl: "",
  id: "",
};
@Component({ components: { FormPage } })
export default class Com extends Vue {
  loading = false;
  title = "";
  detail = {};
  model = {
    ...defaultModel,
  };
  get lang() {
    return this.$store.state.lang;
  }
  @Watch("lang")
  onLangChange() {
    this.getDetail();
  }
  handleBack() {
    this.$router.push({ path: "/" });
  }
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }
  isScrollAtBottom(scroll) {
    // 获取窗口可视区域的高度
    var windowHeight = window.innerHeight;
    // 获取整个文档的高度（包括被滚动隐藏的部分）
    var documentHeight = document.documentElement.scrollHeight;
    // 获取当前滚动的垂直位置
    var scrollPosition = scroll || window.scrollY || window.pageYOffset;
    // 判断是否触底滚动
    return windowHeight + scrollPosition >= documentHeight;
  }
  @Debounce(10)
  handleScroll() {
    const navLinks = document.querySelectorAll(".nav");
    const sections = document.querySelectorAll(".project");
    let scrollTop =
      window.pageYOffset ||
      document.body.scrollTop ||
      document.documentElement.scrollTop;
    let _self = this;
    // 遍历所有目标元素
    sections.forEach(function (section) {
      const sectionTop = section.offsetTop - 100;
      const sectionHeight = section.offsetHeight;
      if (_self.isScrollAtBottom()) {
        if (_self.clickEle) {
          //触底说明点击的元素操作完毕，设置并且进行样式设置。清空元素
          navLinks.forEach(function (link) {
            link.classList.remove("selected");
          });
          const linkTeam = document.querySelectorAll(_self.clickEle);
          linkTeam[0] && linkTeam[0].classList.add("selected");
          _self.clickEle = null;
        } else {
          return false;
        }
      } else {
        // 检查当前滚动位置与目标元素的位置关系
        if (scrollTop >= sectionTop && scrollTop < sectionTop + sectionHeight) {
          // 添加样式到导航链接
          navLinks.forEach(function (link) {
            if (link.getAttribute("data") === section.getAttribute("id")) {
              link.classList.add("selected");
            } else {
              link.classList.remove("selected");
            }
          });
        }
      }
    });
  }
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.getDetail();
    window.scroll(0, 0);
  }
  async getDetail() {
    this.model = { ...defaultModel, ...this.$route.params };
    const { Result } = await this.api.showroomDetail(this.model.id);
    this.detail = Result;
    this.detail.projectValue = JSON.parse(this.detail.projectValue);
    this.detail.typicalCase = JSON.parse(this.detail.typicalCase);
    this.detail.aiProducts = JSON.parse(this.detail.aiProducts);
  }
  // @Debounce(10)
  // handleConsult() {
  //   const element = document.getElementById("consult");
  //   const offset = element.offsetTop - 100;
  //   window.scrollTo({
  //     top: offset,
  //     behavior: "smooth", // 平滑滚动效果
  //   });
  // }
  @Debounce(100)
  scrollToElement(elementId) {
    // document.getElementById(elementId).classList.add("selected");
    const element = document.getElementById(elementId);
    // const navLinks = document.querySelectorAll(".nav");
    // const link = document.querySelectorAll("." + elementId + "-nav");
    // navLinks.forEach(function (link) {
    //   console.log("link", link);
    //   link.classList.remove("selected");
    // });
    // link[0].classList.add("selected");
    if (element) {
      const offset = element.offsetTop - 100; // 向上偏移100px
      if (this.isScrollAtBottom(offset)) {
        this.clickEle = "." + elementId + "-nav";
      }
      window.scrollTo({
        top: offset,
        behavior: "smooth", // 平滑滚动效果
      });
    }
  }
  handleGo(url) {
    if (url) {
      window.open(url);
    } else {
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-detail {
  background: #f5f7fa;
  height: auto;
  width: 10rem;
  padding-top: 124px;
  padding-bottom: 74px;
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #232325;
    line-height: 50px;
    text-align: center;
    img {
      width: 34px;
      margin: 0 10px;
    }
  }
  .subitle {
    font-weight: 400;
    color: #787878;
    line-height: 28px;
    text-align: center;
    margin-top: 14px;
    font-size: 20px;
    margin-bottom: 52px;
  }
  .content-box {
    padding-top: 40px;
  }
  .menu-box {
    margin: 0 auto;
    overflow: hidden;
    z-index: 100;
    .menu {
      height: 60px;
      // background: #f2f6ff;
      position: fixed;
      top: 86px;
      width: 100%;
      display: flex;
      font-size: 12px;
      padding-left: 40px;
      font-weight: 400;
      color: #0d1727;
      line-height: 60px;
      z-index: 100;
      .sub-title {
        cursor: pointer;
        padding-right: 5px;
        &.selected {
          color: #4783f7;
        }
      }
      .back-first {
        position: absolute;
        left: 10px;
        cursor: pointer;
        font-size: 28px;
        .img {
          height: 50px;
          width: 50px;
          background-image: url("../../assets/back.png");
          background-size: cover;
          border: none;
          cursor: pointer;
          outline: none;
        }
        .img:active {
          background-image: url("../../assets/actBack.png");
        }
      }
    }
  }
  .subtitle {
    padding-top: 40px;
    margin-bottom: 26px;
    font-weight: 400;
    color: #0d1727;
    font-size: 22px;
    text-align: center;
  }
  .desc {
    font-size: 16px;
    padding: 20px;
    font-weight: 400;
    color: #374240;
    line-height: 26px;
  }
  .program-value {
    .content {
      padding: 10px;
      font-size: 16px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #f0f0f0;
      .layout-title {
        color: #4b5159;
        font-weight: 500;
        font-size: 16px;
        img {
          width: 14px;
        }
      }
      .layout-des {
        margin-top: 14px;
        color: #4b5159;
        text-align: left;
      }
    }
  }
  .solution-architecture {
    width: 100%;
    height: auto;
    .img-box {
      text-align: center;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .ai-power-products {
    .my-swipe {
      background-color: #323233;
      color: #fff;
    }
    .swiper-content {
      padding-left: 20px;
      padding-right: 20px;
      .products-title {
        padding-top: 20px;
        img {
          width: 25px;
          margin-right: 10px;
        }
        font-weight: 500;
        line-height: 25px;
        font-size: 18px;
      }
      .products-desc {
        font-size: 16px;
        font-weight: 400;
        margin-top: 20px;
        line-height: 26px;
        text-align: left;
      }
    }
    .swiper-img {
      text-align: center;
      img {
        width: 80%;
        height: auto;
      }
    }
  }
  .ai-case {
    .swiper-content {
      height: 100%;
      padding: 20px;
      .case-title {
        img {
          width: 11px;
          margin-right: 4px;
        }
        font-weight: 500;
        color: #4b5159;
        font-size: 18px;
      }
      .case-desc {
        font-size: 16px;
        font-weight: 400;
        color: #4b5159;
        margin-top: 20px;
        line-height: 26px;
      }
    }
    .swiper-img {
      text-align: center;
      img {
        width: 100%;
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
  .target {
    text-align: center;
    align-self: auto;
    margin-top: 22px;
    button {
      height: 30px;
      color: #fff;
      background: #4684f7;
      font-size: 16px;
      border: none;
      border-radius: 4px 4px 4px 4px;
      &[disabled] {
        background-color: #c0c4cc;
        border-color: #ebeef5;
      }
    }
    .tips {
      font-size: 14px;
    }
  }
}
</style>
